import { FC } from 'react';

import { Home } from '@components/Home/home';

export const HomePage: FC = () => {
  return (
    <>
      <Home />
    </>
  );
};
